import React from "react";
import { Button } from "./Button";
import Modal from "./Modal";

const SimpleModal = ({ title, onClose, onSubmit, children, buttonText }) => (
  <Modal>
    <div
      style={{
        background: "#fff",
        padding: "20px",
        borderRadius: "5px",
        width: "400px",
        position: "relative",
      }}
    >
      <div style={{ fontSize: "18px", marginBottom: "30px", color: "#000" }}>
        {title}
      </div>
      <div style={{ marginBottom: "100px" }}>{children}</div>
      <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
        <Button
          onClick={onClose}
          backgroundColor="#F6F8FA"
          color="#000000"
          border="1px solid #000000"
        >
          취소
        </Button>
        <Button
          onClick={onSubmit}
          backgroundColor="#2D2D2D"
          color="#fff"
          border="none"
        >
          {buttonText}
        </Button>
      </div>
    </div>
  </Modal>
);

export default SimpleModal;
